import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { reloadCostReview } from '../../../store/bulk/cost-review/bulk.cost-review.actions';

export const useReloadCostReviewAfterRecommendationsApplied = (hasAppliedRecommendations, isReloadCostReviewDisabled) => {
  const [isWaitingToReloadCostReview, setIsWaitingToReloadCostReview] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (hasAppliedRecommendations && isReloadCostReviewDisabled) {
      setIsWaitingToReloadCostReview(true);
    }
  }, [hasAppliedRecommendations, isReloadCostReviewDisabled]);

  useEffect(() => {
    if (isWaitingToReloadCostReview && !isReloadCostReviewDisabled) {
      setIsWaitingToReloadCostReview(false);
      dispatch(reloadCostReview());
    }
  }, [dispatch, isWaitingToReloadCostReview, isReloadCostReviewDisabled]);

  return {
    isWaitingToReloadCostReview,
  };
};
